import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type LinkProps = {
    href: string;
    children: React.ReactNode;
    newPage?: boolean;
    className?: string;
    tooltip?: string;
};

function Link({ href, children, newPage = false, className = "", tooltip }: LinkProps) {
    const link = (
        <a className={className} href={href} {...(newPage ? { target: "_blank" } : {})}>
            {children}
        </a>
    );

    if (tooltip) {
        const tooltipElement = <Tooltip>{tooltip}</Tooltip>;

        return (
            <OverlayTrigger overlay={tooltipElement} placement="top">
                {link}
            </OverlayTrigger>
        );
    }

    return link;
}

export default Link;
